import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const loading: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  p: 6,
};

export const emptyWrapper: SxProps<Theme> = { p: 4 };

export const tableContainer: SxProps<Theme> = {
  border: `1px solid ${atlasSemantic.color.ui.divider.default}`,
  borderRadius: `${atlasSemantic.radius.md}`,
  overflowX: 'auto',
};

export const table: SxProps<Theme> = { minWidth: 1200 };

export const headerRow: SxProps<Theme> = {
  backgroundColor: atlasSemantic.color.action.secondary.hoverFill,
};

export const cell: SxProps<Theme> = { whiteSpace: 'nowrap' };

export const headerCell: SxProps<Theme> = {
  fontWeight: 700,
  whiteSpace: 'nowrap',
};

export const row: SxProps<Theme> = {
  cursor: 'pointer',
  '&:hover [data-testid="cell-Assigned Case Lead"]': {
    backgroundColor: 'transparent',
  },
};

export const caseName: SxProps<Theme> = {
  textDecoration: 'underline',
  color: atlasSemantic.color.type.default,
};

export const flagCell: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
};

export const reviewerCell: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const paginationRow: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: '16px',
};

export const caseLadCell: SxProps<Theme> = {
  whiteSpace: 'nowrap',
  overflow: 'visible',
  position: 'relative',
  backgroundColor: atlasSemantic.color.surface.default,
  verticalAlign: 'top',
};
